"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Description_1 = require("./Description");
Object.defineProperty(exports, "Description", { enumerable: true, get: function () { return Description_1.Description; } });
//# sourceMappingURL=index.js.map